const indexData = [
  { title: '51黑料吃瓜主线路', desc: '主力访问入口，覆盖全国多节点CDN加速，访问速度快、内容更新及时。', icon: 'ri-router-line' },
  { title: '91黑料吃瓜备用线', desc: '高可用备用线路，主线路拥挤时自动切换，确保访问不中断。', icon: 'ri-shuffle-line' },
  { title: '17黑料吃瓜数字版', desc: '专为移动端优化的数字版本，适配手机浏览器，流量消耗更少。', icon: 'ri-smartphone-line' },
  { title: '黑料吃瓜52线路', desc: '针对特定网络运营商优化的专用通道，解决部分用户访问慢的问题。', icon: 'ri-speed-mini-line' },
  { title: '黑料吃瓜92线路', desc: '海外节点加速线路，适合境外用户快速访问国内爆料内容。', icon: 'ri-global-line' },
  { title: '黑料吃瓜18线路', desc: '最新上线的备用通道，采用新一代加密协议，安全性更高。', icon: 'ri-shield-keyhole-line' },
  { title: '黑料吃瓜数字版总览', desc: '全部数字版本入口集合，一页浏览所有可用线路及其当前状态。', icon: 'ri-dashboard-line' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-section-offset">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">主题索引</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-4">黑料吃瓜全部数字版线路快速导航总览</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {indexData.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6 hover:border-secondary-300 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-white transition-colors mb-3">
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-secondary-600 transition-colors mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}